export default __webpack_public_path__ + "978f330690f92bb49a0d06a3d14ff0fb.png";